module.exports = __webpack_public_path__ + "static/img/recliner.054fb12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/recliner.png
// module id = 1106
// module chunks = 38